interface ProductAttributeDisplayProps {
  label: string;
  value: string;
}
const ProductAttributeDisplay = ({ label, value }: ProductAttributeDisplayProps) => (
  <p className="mb-3 text-left text-sm leading-[17px] md:text-center">
    <strong className="mr-2 font-semibold">{label}:</strong>
    <span>{value}</span>
  </p>
);

export default ProductAttributeDisplay;
